import React from "react";

// Import image
import aiShopifyPopup from "../../assets/img/features/Ai-Shopify Popup.png";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import { Link } from "react-router-dom";

const AIPopup = () => {
  return (
    <div>
      <Header />
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <div
          className="container text-center py-5"
          style={{ maxWidth: "900px" }}
        >
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            AI Shopify Pop-Ups
          </h4>
          <ol
            className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          >
            <li className="breadcrumb-item">
              <Link to={"/"}>Home</Link>
            </li>
            <li className="breadcrumb-item active text-primary">
              AI Shopify Pop-Ups
            </li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* B2B Feature Start */}
      <section className="bg-white p-50">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-4 col-lg-4">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src={aiShopifyPopup}
                    className="img-fluid rounded w-45"
                    alt="AI Shopify Popup"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-8 col-lg-8">
              <h1>Engage, Convert & Retain Customers Instantly</h1>
              <p className="font-size-p">
                Take your Shopify store to the next level with intelligent
                pop-ups designed to capture leads, reduce cart abandonment, and
                boost sales. Our AI-powered pop-up solution helps you engage
                customers at the right moment, offering personalized discounts,
                exit-intent offers, and targeted promotions—leading to higher
                conversions and increased revenue.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* B2B Feature End */}

      {/* Key Features & Benefits Section */}
      <header className="sub-heading-section">
        <h1>Key Features & Benefits</h1>
      </header>
      <div className="container mt-5">
        <div className="row">
          <div className="col-lg-12 mb-4">
            <h2 className="section-title">
              Smart Pop-Up Triggers for Maximum Engagement
            </h2>
            <ul>
              <li>
                <span className="icon-box"></span> Exit-Intent Pop-Ups – Reduce
                cart abandonment with last-minute offers.
              </li>
              <li>
                <span className="icon-box"></span> Time-Delayed Pop-Ups – Engage
                visitors after a set duration on your site.
              </li>
              <li>
                <span className="icon-box"></span> Scroll-Based Pop-Ups –
                Trigger offers when users show interest in products.
              </li>
            </ul>
          </div>
          <div className="col-lg-12 mb-4">
            <h2 className="section-title">
              AI-Driven Personalization & Targeting
            </h2>
            <ul>
              <li>
                <span className="icon-box"></span> Dynamic Product
                Recommendations based on browsing behavior.
              </li>
              <li>
                <span className="icon-box"></span> AI-powered Discounts & Offers
                tailored to customer preferences.
              </li>
              <li>
                <span className="icon-box"></span> Segmented Pop-Ups for new
                visitors, returning customers, and VIP shoppers.
              </li>
            </ul>
          </div>
          <div className="col-lg-12 mb-4">
            <h2 className="section-title">
              Customizable Design & Seamless Shopify Integration
            </h2>
            <ul>
              <li>
                <span className="icon-box"></span> Drag-and-Drop Editor – Easily
                customize pop-ups to match your brand.
              </li>
              <li>
                <span className="icon-box"></span> Mobile-Optimized & Responsive
                for a seamless experience.
              </li>
              <li>
                <span className="icon-box"></span> A/B Testing & Analytics to
                optimize pop-up performance.
              </li>
            </ul>
          </div>
          <div className="col-lg-12 mb-4">
            <h2 className="section-title">
              Lead Capture & Conversion Boosting
            </h2>
            <ul>
              <li>
                <span className="icon-box"></span> Email & SMS Lead Collection
                for remarketing campaigns.
              </li>
              <li>
                <span className="icon-box"></span> One-Click Discount Codes
                applied directly at checkout.
              </li>
              <li>
                <span className="icon-box"></span> Gamified Spin-to-Win Pop-Ups
                to increase engagement.
              </li>
            </ul>
          </div>
        </div>

        {/* Call to Action Section */}
        <section className="cta-section">
          <h2>Start Converting More Visitors Today!</h2>
          <p className="font-size-p">
            Turn visitors into customers with high-converting, AI-driven Shopify
            pop-ups! 🚀
          </p>
        </section>

        {/* Contact Information Section */}
        <div className="row g-4 mb-5">
          <div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.2s">
            <div className="contact-add-item">
              <div className="contact-icon text-primary mb-4">
                <i className="fas fa-map-marker-alt fa-2x"></i>
              </div>
              <div>
                <h4>Website</h4>
                <p className="mb-0">
                  <a href="https://epic-x.io/">epic-x.io</a>
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.4s">
            <div className="contact-add-item">
              <div className="contact-icon text-primary mb-4">
                <i className="fas fa-envelope fa-2x"></i>
              </div>
              <div>
                <h4>Mail Us</h4>
                <p className="mb-0">techsupport@epic-x.io</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.6s">
            <div className="contact-add-item">
              <div className="contact-icon text-primary mb-4">
                <i className="fa fa-phone-alt fa-2x"></i>
              </div>
              <div>
                <h4>Call Us</h4>
                <p className="mb-0">+91-8925696660</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AIPopup;
